import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import DebuggerMixin from "./helpers/debugger-mixin";
import VueDraggable from "vuedraggable";
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import ToggleButton from "vue-js-toggle-button";
import Vue2TouchEvents from "vue2-touch-events";

import "./components";
import * as api from "./api";
import { client } from "./api/request";
import { EnvironmentMixin } from "./helpers/environment-mixin";

api.setToken(store.state.accessToken);
client.logger = console;

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(ToggleButton);
Vue.use(Vue2TouchEvents);
Vue.mixin(DebuggerMixin);
Vue.mixin(EnvironmentMixin);

Vue.component("v-draggable", VueDraggable);
Vue.component("v-multiselect", VueMultiselect);

const params = new URLSearchParams(location.search);
const accessToken = params.get("accessToken");
if (accessToken) {
  store.commit("saveToken", accessToken);
}
if (params.get("mobile")) {
  store.commit("onMobile");
}

(async () => {
  await store.dispatch("debugToken");
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
})();
